'use client';

import React, { useState, useEffect } from 'react';
import Link from 'next/link';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      <header
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          scrolled
            ? 'bg-white/95 backdrop-blur-md shadow-lg py-3'
            : 'bg-transparent py-5'
        }`}
      >
        <div className="w-full flex items-center">
          <div className="container mx-auto container-padding">
            <nav className="flex items-center justify-between">
              {/* Left nav links */}
              <div className="hidden lg:flex items-center space-x-1 flex-1 justify-end pr-8">
                {['About', 'Platform', 'Benefits']?.map((item) => (
                  <Link
                    key={item}
                    href={`/${item?.toLowerCase()}`}
                    className={`px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 inline-block ${
                      scrolled
                        ? 'text-gray-700 hover:text-gray-900 hover:bg-gray-100' :'text-white/90 hover:text-white hover:bg-white/10'
                    }`}
                  >
                    {item}
                  </Link>
                ))}
              </div>

              {/* Center Logo */}
              <Link href="/" className="flex items-center justify-center">
                <img
                  src="/assets/images/NeXSYS_logo_-_Copy-1774454634126.png"
                  alt="NeXSYS Logo"
                  className="h-12 w-auto"
                />
              </Link>

              {/* Right nav links */}
              <div className="hidden lg:flex items-center space-x-1 flex-1 pl-8">
                {['Products', 'Partners', 'News']?.map((item) => (
                  <Link
                    key={item}
                    href={`/${item?.toLowerCase()}`}
                    className={`px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 inline-block ${
                      scrolled
                        ? 'text-gray-700 hover:text-gray-900 hover:bg-gray-100' :'text-white/90 hover:text-white hover:bg-white/10'
                    }`}
                  >
                    {item}
                  </Link>
                ))}
              </div>

              {/* Mobile menu button */}
              <button
                className={`inline-flex items-center justify-center h-10 w-10 lg:hidden rounded-md transition-all duration-300 ${
                  scrolled ? 'text-gray-700' : 'text-white'
                }`}
                onClick={() => setMobileOpen(!mobileOpen)}
                aria-label="Toggle menu"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="h-6 w-6"
                >
                  {mobileOpen ? (
                    <>
                      <line x1="18" y1="6" x2="6" y2="18" />
                      <line x1="6" y1="6" x2="18" y2="18" />
                    </>
                  ) : (
                    <>
                      <line x1="4" x2="20" y1="12" y2="12" />
                      <line x1="4" x2="20" y1="6" y2="6" />
                      <line x1="4" x2="20" y1="18" y2="18" />
                    </>
                  )}
                </svg>
              </button>
            </nav>
          </div>

          {/* Say Hello CTA - fixed right */}
          <Link
            href="/contact"
            className="items-center justify-center gap-2 whitespace-nowrap text-sm shadow-md hover:shadow-lg hover:-translate-y-0.5 h-10 hidden lg:flex fixed right-0 top-3 bg-banana text-banana-foreground font-semibold rounded-l-lg rounded-r-none px-6 py-3 z-50 transition-all duration-300"
          >
            Say Hello
          </Link>
        </div>
      </header>
      {/* Mobile Menu */}
      {mobileOpen && (
        <div className="fixed inset-0 z-40 bg-white pt-20">
          <nav className="flex flex-col p-6 space-y-2">
            {['About', 'Platform', 'Benefits', 'Products', 'Partners', 'News']?.map((item) => (
              <Link
                key={item}
                href={`/${item?.toLowerCase()}`}
                className="px-4 py-3 rounded-lg text-base font-medium text-gray-700 hover:text-gray-900 hover:bg-gray-100 transition-all duration-200"
                onClick={() => setMobileOpen(false)}
              >
                {item}
              </Link>
            ))}
            <Link
              href="/contact"
              className="mt-4 px-6 py-3 bg-banana text-banana-foreground font-semibold rounded-lg text-center transition-all duration-200"
              onClick={() => setMobileOpen(false)}
            >
              Say Hello
            </Link>
          </nav>
        </div>
      )}
    </>
  );
}
